import React from "react";
import { Pagination } from "@mui/material";

import styles from "./DataTablePagination.module.css";

export const DataTablePagination = ({
  start,
  end,
  total,
  page,
  totalPages,
  onPageChange,
  rowsOptions,
  rowsPerPage,
  onRowsChange,
}) => {
  return (
    <div className={styles.paginationWrapper}>
      <div className={styles.leftGroup}>
        <p className={styles.resultsInfo}>
          {start}-{end} of {total} results
        </p>
        {rowsOptions && (
          <div className={styles.rowsControl}>
            <select
              className={styles.rowsSelect}
              value={rowsPerPage}
              onChange={(e) => {
                const val = e.target.value;
                onRowsChange(val === "All" ? "All" : Number(val));
              }}
            >
              {rowsOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt === "All" ? "All" : opt}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
      {rowsPerPage !== "All" && (
        <Pagination
          count={totalPages}
          page={page}
          onChange={(_, value) => onPageChange?.(value)}
        />
      )}
    </div>
  );
};
